import React, {createContext, useContext} from 'react';

const MediaBrowserLoadingContext = createContext<boolean>(false);

export const MediaBrowserLoadingProvider: React.FC<{
  loading: boolean;
  children: React.ReactNode;
}> = ({loading, children}) => (
  <MediaBrowserLoadingContext.Provider value={loading}>
    {children}
  </MediaBrowserLoadingContext.Provider>
);

export function useMediaBrowserLoading(): boolean {
  return useContext(MediaBrowserLoadingContext);
}
